import React, { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Container } from "reactstrap"
import styled from "styled-components"
import classNames from "classnames"
import { media } from "utils/Media"
import { LinkSearchReplace } from "utils/LinkSearchReplace"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from "@fortawesome/free-solid-svg-icons"

const CookieWrap = styled(Container)`
	background: ${props => props.theme.colors.grey};
	width: 100%;
	position: relative;

	color: ${props => props.theme.colors.white};
	font-size: ${props => props.theme.font.size.sm};

	@media ${media.md} {
		font-size: ${props => props.theme.font.size.base};
	}

	&.hide {
		height: 0;
	}

	a {
		color: ${props => props.theme.colors.secondary};
		font-weight: ${props => props.theme.font.family.bold};
		text-decoration: underline;
		
		&:hover { 
			color: ${props => props.theme.colors.primary};
			text-decoration: underline;
		}
	}
`

const CookieContainer = styled(Container)`
	text-align: center;
	padding: .75rem 0;
`

const Close = styled.button`
	position: absolute;
	background: 0;
	right: 1rem;
	top: .5rem;
	border: 0;
	padding: 0;

	@media ${media.md} {
		top: 50%;
		transform: translateY(-50%);
	}

	svg {
		color: ${props => props.theme.colors.white};
		display: block;
		font-size: 1rem;
		line-height: .7;
		max-width: 20px;
	}
`

const HeaderAnnouncement = (props) => {
	const [hidden, setHidden] = useState(false)
	const [lastScrollTop, setLastScrollTop] = useState(0)

	useEffect(() => {
		if (!window.localStorage.getItem('announcement')) {

			const hideShow = () => {
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop
				const scrollDirection = scrollTop > lastScrollTop ? "down" : "up"
				let hidden
		
				if (Math.abs(scrollTop - lastScrollTop) > 200) {
					if (scrollDirection === "up") {
						hidden = false
					} else {
						hidden = true
					}
		
					const newLastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
		
					setHidden(hidden)
					setLastScrollTop(newLastScrollTop)
				}
			}

			window.addEventListener("scroll", hideShow)

			return () => {
				window.removeEventListener('scroll', hideShow);
			}
		} else {
			setHidden(true)
		}
	})

	const data = useStaticQuery(graphql`
		query {
			allWp {
				edges {
					node {
						...optionsFragment
					}
				}
			}
		}
	`)

	const acceptCookies = () => {
		localStorage.setItem('announcement', '1');
		setHidden(true)
	}

	const { headerAnnouncementText } = data.allWp?.edges[0]?.node?.options?.acfOptions

	if (headerAnnouncementText && !hidden) {
		return (
			<CookieWrap fluid 
				className={classNames({ 
					hide: hidden
				}
			)}>
				<CookieContainer dangerouslySetInnerHTML={{ __html: LinkSearchReplace(headerAnnouncementText) }} />
				<Close onClick={acceptCookies}>
					<FontAwesomeIcon icon={faTimes} />
				</Close>
			</CookieWrap>
		)
	} else return ""
}

export default HeaderAnnouncement